import React from 'react';
import './ProductCardSkeleton.css';

function ProductCardSkeleton({ viewMode = 'grid', count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={`product-card-skeleton product-card-skeleton--${viewMode}`}
          style={{ '--skeleton-index': index }}
        >
          <div className="skeleton-image" />
          <div className="skeleton-content">
            <div className="skeleton-title" />
            <div className="skeleton-description" />
            <div className="skeleton-footer">
              <div className="skeleton-price" />
              <div className="skeleton-button" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default ProductCardSkeleton;
